import HttpClient from './http-clients/portaljad'

const baseUrl = 'menu-cliente'

export default class MenuService {
  static async findAll() {
    const { data } = await HttpClient.get(baseUrl)
    return data.body
  }
}